import axiosInstance from 'utils/InstanceAxios/InstanceAxios';
import { Types } from '../reducers/internalDocuments';
import * as serverRoutes from 'utils/consts/serverRoutes.js';
import { toast } from 'react-toastify';

//Synchronous

//Asynchronous
export const getDocuments = (page, limit, query, sort = "") => {
  return (dispatch) => {
    dispatch({
      type: Types.SET_LOADING,
    });

    axiosInstance.get(serverRoutes.InternalDocuments.crud('', { page, limit, query, sort }))
      .then((response) => {
        dispatch({
          type: Types.GET_DOCUMENTS,
          payload: response.data,
        })
      })
      .catch((err) => {
        console.log(err)
      })
  }
}

export const getDocument = (documentName) => {
  return dispatch => {
    dispatch({
      type: Types.SET_LOADING,
    });

    axiosInstance.get(serverRoutes.InternalDocuments.crud(`/${documentName}`))
      .then(response => {
        dispatch({
          type: Types.GET_DOCUMENT,
          payload: response.data,
        })
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: Types.GET_DOCUMENT,
          payload: null,
        });
      });
  }
}

export const createDocument = (document, callback) => {
  return dispatch => {
    axiosInstance.post(serverRoutes.InternalDocuments.crud(), document)
      .then(response => {
        dispatch({
          type: Types.CREATE_DOCUMENTS,
          payload: response.data,
        });
        callback(true);
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: Types.CREATE_DOCUMENTS,
          payload: null,
        });
        callback(false)
      })
  }
}

export const updateDocument = (id, document, callback) => {
  return (dispatch, getState) => {
    axiosInstance.put(serverRoutes.InternalDocuments.crud(`/${id}`), {document})
      .then(response => {
        dispatch({
          type: Types.UPDATE_DOCUMENTS,
          payload: response.data,
        });
        callback(true);
      })
      .catch((err) => {
        console.log(err);
        callback(false);
        const { documents } = getState();
        dispatch({
          type: Types.UPDATE_DOCUMENTS,
          payload: documents?.document,
        });
        toast.error(`Erro: ${err.response?.data?.error?.message || err.response?.data?.error || err.response?.data }`, { autoClose: 10000 });
      })
  }
}

export const deleteDocument = (id, callback) => {
  return dispatch => {
    axiosInstance.delete(serverRoutes.InternalDocuments.crud(`/${id}`))
      .then(response => {
        dispatch({
          type: Types.DELETE_DOCUMENTS,
        });
        callback();
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: Types.DELETE_DOCUMENTS,
        });
      })
  }
}

export const uploadDocumentFile = (file, callback) => {
  return dispatch => {
      axiosInstance.post(serverRoutes.InternalDocuments.crud('/uploadDocument'), file, {
          onUploadProgress: e => {
              const progress = parseInt(Math.round((e.loaded * 100) / e.total));
              callback({ progress });
          }
      })
      .then(response => {
          dispatch({
              type: Types.UPLOAD_DOCUMENT_FILE,
              payload: {content: response.data.uploadedDocumentFile, connect: true},
          });

          callback({
              uploaded: true,
              id: response.data.uploadedDocumentFile._id,
              // url: response.data.uploadedDocumentFile.url,
              // path: response.data.path,
          });
      })
      .catch(err => {
          dispatch({
              type: Types.UPLOAD_DOCUMENT_FILE,
              payload: null,
          });
          callback({
              error: true,
              id: err.response?.data?._id,
          });
      });
  }
}

export const deleteDocumentFile = (fileId, callback) => {
  return dispatch => {
      axiosInstance.delete(serverRoutes.InternalDocuments.crud(`/uploadDocument/${fileId}`))
      .then(response => {
          dispatch({
              type: Types.DELETE_DOCUMENT_FILE,
          });
          callback();
      })
      .catch(err => {
          console.log(err);
          callback();
      });
  }
}

export const showAllDocumentsAvailable = () => {
  return dispatch => {
    dispatch({
      type: Types.SET_LOADING,
    });

    axiosInstance.get(serverRoutes.InternalDocuments.showDocument())
      .then(response => {
        dispatch({
          type: Types.SHOW_ALL_DOCUMENTS,
          payload: response.data,
        })
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: Types.SHOW_ALL_DOCUMENTS,
          payload: null,
        });
      });
  }
}

export const showDocument = (documentName) => {
  return dispatch => {
    dispatch({
      type: Types.SET_LOADING,
    });

    axiosInstance.get(serverRoutes.InternalDocuments.showDocument(`/${documentName}`))
      .then(response => {
        dispatch({
          type: Types.SHOW_DOCUMENT,
          payload: response.data,
        })
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: Types.SHOW_DOCUMENT,
          payload: null,
        });
      });
  }
}
